import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import { Colors } from '../../theme';
import { validateEmail } from 'shared';
import '@fontsource/work-sans';
import '@fontsource/pt-serif';

interface EmailInputProps {
    id?: string;
    label: string;
    onChange: (value: string, isValid: boolean) => void;
    value: string;
    error: boolean;
    errorText: string;
}

const styles = {
    label: {
        fontFamily: 'Outfit',
        color: Colors.darkNavy,
        lineHeight: '1.2em',
        minHeight: '1.2em',
        display: 'block',
    },
    errorText: {
        fontFamily: 'Outfit',
        color: Colors.mediumRed,
        fontSize: 12,
        margin: 0,
    },
};

const StyledInput = styled('input')({
    '&:hover': {
        outline: 'none',
    },
    '&:focus': {
        outline: 'none',
    },
    '&::placeholder': {
        color: Colors.mediumNavy,
    },
    borderBottomColor: Colors.mediumNavy,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderWidth: 0,
    borderBottomWidth: 1,
    width: '100%',
    autoCapitalize: 'none',
});

export default function EmailInput({ label, onChange, value, error, errorText, id }: EmailInputProps) {
    const [touched, setTouched] = useState(false);

    function getPlaceholder() {
        return value ? '' : label;
    }

    return (
        <Grid container direction="column">
            <Grid item>
                <label style={{ ...styles.label, visibility: value ? 'visible' : 'hidden' }}>{label}</label>
            </Grid>
            <Grid item>
                <StyledInput
                    id={id}
                    type="email"
                    value={value}
                    onChange={(e) => onChange(e.target.value, validateEmail(e.target.value))}
                    onBlur={() => setTouched(true)}
                    placeholder={getPlaceholder()}
                    style={{ color: Colors.darkNavy }}
                />
            </Grid>
            {touched && error ? (
                <Grid container item alignItems="center" style={{ paddingTop: 5 }}>
                    <Grid
                        item
                        style={{
                            paddingLeft: 5,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <CancelIcon style={{ color: Colors.mediumRed, fontSize: 14, marginRight: 4 }} />
                        <p style={styles.errorText}>{errorText}</p>
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
}
